import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { NotificationModel, NotificationsService, NotificationTypes } from '../../../shared/services/notifications/notifications.service';
import { CustomerDto } from '../interfaces/customer-dto.interface';
import { CustomerService } from '../services/customer.service';
import { NavigationStateService } from '@shared/services';

@Component({
    selector: 'customer-edit-component',
    templateUrl: './customer-edit.control.html',
    styleUrls: ['./customer-edit.control.scss'],
    standalone: false
})
export class EditCustomerComponent implements OnInit {
  isLoading = false;
  customerUuid: string;
  backButtonText = '';

  constructor(
    private _customerService: CustomerService,
    private _notificationsService: NotificationsService,
    private _activatedRoute: ActivatedRoute,
    private _navService: NavigationStateService
  ) {}

  ngOnInit() {
    this.customerUuid = this._activatedRoute.snapshot?.params.customerUuid;
    this.backButtonText = history.state?.prevLabel ?? (this._activatedRoute.snapshot?.queryParams['fromCustomerProfile'] ? 'Customer' : 'Customers');
  }

  updateCustomer([customerName, data]: [string, CustomerDto]) {
    this.isLoading = true;
    // start form loading

    this._customerService
      .updateCustomer(this.customerUuid, data)
      .pipe(first())
      .subscribe({
        next: () => {
          const notification: NotificationModel = {
            message: `Successfully updated customer: ${customerName}.`,
            action: 'Close',
            type: NotificationTypes.SUCCESS
          };
          this._notificationsService.openSnackBar(notification);
          this.isLoading = false;
          this.navigateBack();
        },
        error: error => {
          console.error(error);
          const notification: NotificationModel = {
            message: error.message || `Error updating customer. Please try again.`,
            messages: error.error?.message,
            action: 'Close',
            type: NotificationTypes.ERROR
          };
          this._notificationsService.openSnackBar(notification);
          this.isLoading = false;
        }
      });
  }

  navigateBack() {
    this._navService.goBack();
  }
}
